import * as Yup from 'yup'

export const getValidationSchema = (mode: 'edit' | 'add') => {
  const base = {
    stock: Yup.number()
      .typeError('Introduceți un număr')
      .required('Soldul este obligatoriu')
  }

  if (mode === 'add') {
    return Yup.object().shape({
      ...base,
      shopCode: Yup.string().required('Magazinul este obligatoriu'),
      supplierCode: Yup.number().typeError('Introduceți un număr').required('Codul furnizor este obligatoriu'),
      dsSupportTypeId: Yup.mixed().required('Tipul suport este obligatoriu')
    })
  }

  return Yup.object().shape(base)
}

export const extractShopCode = (
  val?: string,
  opts: { digitsOnly?: boolean } = {}
): string | undefined => {
  if (val == null) return val
  const s = String(val).trim()

  const open = s.lastIndexOf('(')
  const close = s.lastIndexOf(')')
  let code =
    open !== -1 && close !== -1 && close > open
      ? s.slice(open + 1, close).trim()
      : s.trim()

  code = code.replace(/\s+/g, ' ').trim()

  if (opts.digitsOnly) {
    code = code.replace(/\D+/g, '')
  }

  return code
};

